import { ApiCompetition } from "../types";

export default function getCanSeeLeaderboard(competition: ApiCompetition) {
  if (competition.role === "MASTER" || competition.role === "STAFF_JUDGE") {
    return true;
  }
  if (
    competition.role === "JUDGE" &&
    competition.settings.judgesCanSeeLeaderboard
  ) {
    return true;
  }
  return (
    competition.liveLeaderboard ||
    (competition.endTime && new Date(competition.endTime) < new Date())
  );
}
